import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Breadcrumb,
  Table,
  FormGroup,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import toastr from "toastr";
import { Formik } from "formik";
import * as Yup from "yup";

import CustomNavbar from "../../components/CustomNavbar";

import messages from "../../redux/messages";

import SidebarDashboard from "../../components/SidebarDashboard";
import { getNineBoxes } from "../../redux/capacitacionDesarrollo/NineBoxes/actions";
import Multiselect from "../../components/Clima/Multiselect";

import { getDivision } from "../../redux/division/actions";
import { getOrgs } from "../../redux/organization/actions";
import { getAreasJerarquia } from "../../redux/areasfuncional/actions";
import { useHistory } from "react-router-dom";
import ReactChipInput from "react-chip-input";

import userperfil from "../../images/userperfil.png";

import "../../css/capacitacion.css";

//
// import CustomPagint from "../../../components/CustomPagint";

//Redux
import {
  getFormEvalCapa,
  saveFormEvalCapa,
  editFormEvalCapa,
} from "../../redux/capacitacionDesarrollo/formEvalCapa/actions";
import { getEmployee } from "../../redux/employees/actions";
import Item from "antd/lib/list/Item";

const FormEvalCapa = (props) => {
  const schema = Yup.object().shape({
    nombre: Yup.string().ensure().required("**Campo requerido"),
    codigo: Yup.number().required("**Campo requerido"),
  });
  //
  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  const [showModal, setShowModal] = useState(false);

  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //

  const fecha = new Date();
  var n = fecha.getFullYear();

  const [filter, setFilter] = useState("");
  const [colabs, setColabs] = useState([]);

  const [_orgs, setOrgs] = useState([]);
  const [_orgsId, setOrgsId] = useState("");
  const [_orgsName, setOrgsName] = useState("");
  const [validOrgs, setValidOrgs] = useState(true);
  const [submitOrgs, setSubmitOrgs] = useState(false);
  const [_division, setDivision] = useState([]);
  const [_divisionId, setDivisionId] = useState("");
  const [_divisionName, setDivisionName] = useState("");
  const [validDivision, setValidDivision] = useState(true);
  const [submitDivision, setSubmitDivision] = useState(false);
  const [_areas, setAreas] = useState([]);
  const [_areasId, setAreasId] = useState("");
  const [_areasName, setAreasName] = useState("");
  const [validAreas, setValidAreas] = useState(true);
  const [submitAreas, setSubmitAreas] = useState(false);
  const [chips, setChips] = useState([]);
  const [anioSelected, setAnioSelected] = useState(n);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [employeeSelected, setEmployeeSelected] = useState(null);
  const [validated, setValidated] = useState(false);
  // const [timer, setTimer] = useState(null);

  //Comentario, Check
  const [comment, setComment] = useState("");
  const [metricScore, setMetricScore] = useState([
    {
      factor: 1,
      metrica: 0,
    },
    {
      factor: 2,
      metrica: 0,
    },
    {
      factor: 3,
      metrica: 0,
    },
    {
      factor: 4,
      metrica: 0,
    },
    {
      factor: 5,
      metrica: 0,
    },
  ]);

  //
  const dispatch = useDispatch();
  const history = useHistory();

  //hooks
  const {
    loaderFormEvalCapa,
    formEvalCapa,
    formEvalCapaFail,
    saveLoaderFormEvalCapa,
    formEvalCapaFormError,
  } = useSelector((store) => store.formEvalCapa);
  const id = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);

  // Métodos
  const _getFormEvalCapa = () =>
    dispatch(
      getFormEvalCapa({
        id: parseInt(props.match.params.id),
        colaborador: parseInt(props.match.params.id_empleado),
      })
    );

  useEffect(() => {
    if (id && userType) {
      dispatch(getEmployee(id, parseInt(userType)));
      _getFormEvalCapa();
    }
  }, [id, userType]);

  useEffect(() => {
    if(!!formEvalCapa &&
      !!formEvalCapa.formulario &&
      !!formEvalCapa.formulario.comentario){
        setComment(formEvalCapa.formulario.comentario);
    }else{
      setComment("");
    }
    if (
      !!formEvalCapa &&
      !!formEvalCapa.formulario &&
      !!formEvalCapa.formulario.respuestas.length > 0
    ) {
      setMetricScore((actual) => {
        let newValue;
        formEvalCapa.formulario.respuestas.forEach((element) => {
          newValue = actual.map((metric) => {
            if (metric.factor == element.id_factor) {
              metric.metrica = !!element.metrica_puntos
                ? element.metrica_puntos
                : 0;
            }
            return metric;
          });
        });
        return newValue;
      });
    } else {
      setMetricScore((prev) => {
        return prev.map((metric) => {
          metric.metrica = 0;
          return metric;
        });
      });
    }
  }, [formEvalCapa]);

  const handleMetricScore = (e) => {
    setMetricScore((actual) => {
      let newValue = actual.map((metric) => {
        if (metric.factor == e.target.id) {
          metric.metrica = parseInt(e.target.value);
        }
        return metric;
      });
      return newValue;
    });
  };

  const handleComment = (e) => {
    setComment(e.target.value);
  };

  const handleSubmit = () => {
    const dataForm = {
      id: parseInt(props.match.params.id),
      colaborador: parseInt(props.match.params.id_empleado),
      comentario: comment,
      respuestas: metricScore.map((metric) => {
        let metConvert;
        switch (metric.metrica) {
          case 100:
            metConvert = 1;
            break;
          case 80:
            metConvert = 2;
            break;
          case 60:
            metConvert = 3;
            break;
          case 40:
            metConvert = 4;
            break;
          case 10:
            metConvert = 5;
            break;

          default:
            metConvert = 0;
            break;
        }

        return { factor: `${metric.factor}`, metrica: `${metConvert}` };
      }),
    };

    dispatch(saveFormEvalCapa(dataForm));
  };

  // //Nivel
  // const calculateScore = ()=>{
  //   {formEvalCapa &&
  //     formEvalCapa.formulario &&
  //     formEvalCapa.formulario.nivel
  //       ? formEvalCapa.formulario.nivel
  //       : ""}
  // }

  //Descarga
  const htmlToImg = async () => {
    try {
      setLoadingPrint(true);
      const input = document.getElementById("formPrint");
      html2canvas(input).then((canvas) => {
        let imgWidth = 200;
        let imgHeight = (canvas.height * imgWidth) / canvas.width;
        // const pdf = new jsPDF("p", "mm", [215, 354]);
        let pdf = jsPDF("p", "mm", "a4");
        pdf.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight);
        pdf.save("F-439v2 Formato Evaluación de Capacitaciones");
        setLoadingPrint(false);
      });
    } catch (error) {
      console.log(error);

      setLoadingPrint(false);
    }
  };

  const evaluateLevel = (level) => {
    if (level >= 0 && level < 60) {
      return (
        <>
          No eficaz
          <br />
          Resultado insuficiente
        </>
      );
    } else if (level > 59 && level < 81) {
      return (
        <>
          Eficaz
          <br />
          Resultado suficiente
        </>
      );
    } else if (level > 80 && level <= 100) {
      return (
        <>
          Eficaz
          <br />
          Resultado satisfactorio - Alto
        </>
      );
    } else {
      return "No entra en ninguna categoria";
    }
  };
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex flex-wrap justify-content-start align-items-center">
              <Button
                onClick={() => history.goBack()}
                variant="link"
                className="font-weight-bold mr-4 text-dark"
              >
                <i className="material-icons">arrow_back</i>
              </Button>
              <Breadcrumb className="pb-0">
                <Breadcrumb.Item
                  title
                  className="text-uppercase"
                  onClick={() => history.goBack()}
                >
                  EVENTOS DE CAPACITACION
                </Breadcrumb.Item>
                <Breadcrumb.Item active title className="text-uppercase">
                  F-439v2 EVALUACION DEL PERSONAL DE PARTICIPACION EN
                  CAPACITACION
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className="px-2">
            <hr />
          </div>
          {/* Instrucciones */}
          <div className="my-4 mx-4 border-left border-warning">
            <Alert variant="light">
              <p>
                Seleccione el Nivel que define mejor el desempeño del
                colaborador según el factor, tomando en cuenta como Excelente la
                calificacion mayor y Deficiente como la menor.
              </p>
            </Alert>
          </div>
          <Row className="justify-content-sm-end align-items-center flex-nowrap pb-2">
            <Col xs="auto">
              <ButtonGroup>
                <Button
                  id=""
                  variant="warning"
                  size="sm"
                  className="rounded-pill"
                  onClick={() => {
                    htmlToImg();
                  }}
                  disabled={loadingPrint}
                >
                  {loadingPrint ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                        size="sm"
                      />
                    </div>
                  ) : (
                    <b>Descargar</b>
                  )}
                </Button>

                <Button
                  id=""
                  variant="secondary"
                  size="sm"
                  className="mx-2 rounded-pill"
                  onClick={handleSubmit}
                >
                  <b>Guardar</b>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div id="formPrint">
            <Col md="12" className="px-0 mx-auto">
              <Card
                className="border border-muted rounded  bg-white"
                style={{ border: "1px solid #ced4da" }}
              >
                <Card.Header className=" text-muted text-uppercase d-flex justify-content-sm-center align-items-center flex-nowrap">
                  <h6>
                    F-439V2 EVALUACION DEL PERSONAL DE PARTICIPACION EN
                    CAPACITACION
                  </h6>
                </Card.Header>
                <br />
                <Card.Header className="card-crear text-muted text-uppercase d-flex flex-wrap justify-left-between align-items-left text-justify">
                  <h6>DATOS DEL EMPLEADO</h6>
                </Card.Header>
                <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
                  <Row className="justify-content-sm-center align-items-center flex-nowrap">
                    <Col md="12">
                      <Row className="mb-0">
                        <Table striped bordered hover responsive>
                          <tbody>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                Empresa
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                {formEvalCapa &&
                                formEvalCapa.formulario &&
                                formEvalCapa.formulario.empresa
                                  ? formEvalCapa.formulario.empresa
                                  : ""}
                              </td>
                            </tr>

                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                País
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                {formEvalCapa &&
                                formEvalCapa.formulario &&
                                formEvalCapa.formulario.pais
                                  ? formEvalCapa.formulario.pais
                                  : "Sin Asignar"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                Nombre de Capacitación
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                {formEvalCapa &&
                                formEvalCapa.formulario &&
                                formEvalCapa.formulario.nombre_capacitacion
                                  ? formEvalCapa.formulario.nombre_capacitacion
                                  : ""}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                Objetivo de Capacitación
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                {formEvalCapa &&
                                 formEvalCapa.formulario &&
                                 formEvalCapa.formulario.objetivo_capacitacion
                                  ? formEvalCapa.formulario.objetivo_capacitacion
                                  : ""}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                Nombre del Empleado
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                {formEvalCapa &&
                                formEvalCapa.formulario &&
                                formEvalCapa.formulario.nombre_empleado
                                  ? formEvalCapa.formulario.nombre_empleado
                                  : ""}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                Área de Trabajo
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                {formEvalCapa &&
                                formEvalCapa.formulario &&
                                formEvalCapa.formulario.area
                                  ? formEvalCapa.formulario.area
                                  : ""}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                Fecha de Evaluación
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                {formEvalCapa &&
                                formEvalCapa.formulario &&
                                formEvalCapa.formulario.fecha_evaluacion
                                  ? formEvalCapa.formulario.fecha_evaluacion
                                  : ""}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <Card
                className="border border-muted rounded bg-white"
                style={{ border: "1px solid #ced4da" }}
              >
                <Card.Header className="card-crear text-muted text-uppercase d-flex flex-wrap justify-left-between align-items-left text-justify">
                  <h6>
                    EVALUACION DE LA FORMACION IMPARTIDA A ESTE EMPLEADO EN ESTE
                    CURSO
                  </h6>
                  <div className="ml-auto d-flex flex-wrap justify-content-between align-items-center">
                    {/* <b className="text-light text-uppercase">
                    {nota ? nota + "%" : "no evaluado"}
                    {desempeño && desempeño !== "" ? " - " + desempeño : ""}
                  </b> */}
                  </div>
                </Card.Header>
                <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
                  <Row className="justify-content-sm-center align-items-center flex-nowrap">
                    <Col md="12">
                      <Row className="mb-0">
                        <Table striped bordered hover responsive>
                          <thead>
                            <tr>
                              <th className="text-center">FACTORES</th>
                              <th className="text-center">
                                EXELENTE <br />
                                100%{" "}
                              </th>
                              <th className="text-center">
                                MUY BUENO <br /> 80%
                              </th>
                              <th className="text-center">
                                BUENO <br />
                                60%
                              </th>
                              <th className="text-center">
                                REGULAR <br />
                                40%
                              </th>
                              <th className="text-center">
                                DEFICIENTE <br />
                                10%
                              </th>
                              <th className="text-center">NIVEL</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                 ¿El colaborador(a)  están aplicando los conocimientos y habilidades adquiridos en la capacitación en su trabajo diario? Se puede evaluar si están utilizando nuevas técnicas, herramientas o enfoques aprendidos.
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[0].metrica == 100}
                                    onChange={handleMetricScore}
                                    value={100}
                                    label=""
                                    name={"desempeño"}
                                    type="radio"
                                    id={`1`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[0].metrica == 80}
                                    onChange={handleMetricScore}
                                    value={80}
                                    label=""
                                    name={"desempeño"}
                                    type="radio"
                                    id={`1`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[0].metrica == 60}
                                    onChange={handleMetricScore}
                                    value={60}
                                    label=""
                                    name={"desempeño"}
                                    type="radio"
                                    id={`1`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[0].metrica == 40}
                                    onChange={handleMetricScore}
                                    value={40}
                                    label=""
                                    name={"desempeño"}
                                    type="radio"
                                    id={`1`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[0].metrica == 10}
                                    onChange={handleMetricScore}
                                    value={10}
                                    label=""
                                    name={"desempeño"}
                                    type="radio"
                                    id={`1`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td
                                rowspan="5"
                                // scope="col"
                                style={{ backgroundColor: "white" }}
                                class="text-center align-middle"
                              >
                                <b>
                                  {formEvalCapa &&
                                  formEvalCapa.formulario &&
                                  formEvalCapa.formulario.nivel ? (
                                    <>
                                      {formEvalCapa.formulario.nivel}
                                      {"%"}
                                      <br />
                                      {evaluateLevel(
                                        formEvalCapa.formulario.nivel
                                      )}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                ¿Ha mejorado el desempeño del colaborador(a)  en áreas específicas relacionadas con la capacitación? Esto podría incluir métricas de productividad, calidad del trabajo, velocidad de ejecución, etc.
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[1].metrica == 100}
                                    onChange={handleMetricScore}
                                    value={100}
                                    label=""
                                    name={"calidad"}
                                    type="radio"
                                    id={`2`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[1].metrica == 80}
                                    onChange={handleMetricScore}
                                    value={80}
                                    label=""
                                    name={"calidad"}
                                    type="radio"
                                    id={`2`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[1].metrica == 60}
                                    onChange={handleMetricScore}
                                    value={60}
                                    label=""
                                    name={"calidad"}
                                    type="radio"
                                    id={`2`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[1].metrica == 40}
                                    onChange={handleMetricScore}
                                    value={40}
                                    label=""
                                    name={"calidad"}
                                    type="radio"
                                    id={`2`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[1].metrica == 10}
                                    onChange={handleMetricScore}
                                    value={10}
                                    label=""
                                    name={"calidad"}
                                    type="radio"
                                    id={`2`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                ¿El colaborador (a) aplica lo aprendido? Ya que al efectuar retroalimentación con el colaborador , muestra conocimiento sobre el tema capacitado.
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[2].metrica == 100}
                                    onChange={handleMetricScore}
                                    value={100}
                                    label=""
                                    name={"aplicacion"}
                                    type="radio"
                                    id={`3`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[2].metrica == 80}
                                    onChange={handleMetricScore}
                                    value={80}
                                    label=""
                                    name={"aplicacion"}
                                    type="radio"
                                    id={`3`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[2].metrica == 60}
                                    onChange={handleMetricScore}
                                    value={60}
                                    label=""
                                    name={"aplicacion"}
                                    type="radio"
                                    id={`3`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[2].metrica == 40}
                                    onChange={handleMetricScore}
                                    value={40}
                                    label=""
                                    name={"aplicacion"}
                                    type="radio"
                                    id={`3`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[2].metrica == 10}
                                    onChange={handleMetricScore}
                                    value={10}
                                    label=""
                                    name={"aplicacion"}
                                    type="radio"
                                    id={`3`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                El colaborador (a) evidencia mejoramiento en las competencias después de la capacitacion ,  mejorando  el desempeño de sus funciones.
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[3].metrica == 100}
                                    onChange={handleMetricScore}
                                    value={100}
                                    label=""
                                    name={"espiritu"}
                                    type="radio"
                                    id={`4`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[3].metrica == 80}
                                    onChange={handleMetricScore}
                                    value={80}
                                    label=""
                                    name={"espiritu"}
                                    type="radio"
                                    id={`4`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[3].metrica == 60}
                                    onChange={handleMetricScore}
                                    value={60}
                                    label=""
                                    name={"espiritu"}
                                    type="radio"
                                    id={`4`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[3].metrica == 40}
                                    onChange={handleMetricScore}
                                    value={40}
                                    label=""
                                    name={"espiritu"}
                                    type="radio"
                                    id={`4`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[3].metrica == 10}
                                    onChange={handleMetricScore}
                                    value={10}
                                    label=""
                                    name={"espiritu"}
                                    type="radio"
                                    id={`4`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                El colaborador (a) tras la capacitacion recibida busca constantemente nuevas formas para optimizar las tareas , Se puede evaluar si están abordando los desafíos de manera más efectiva y eficiente.
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[4].metrica == 100}
                                    onChange={handleMetricScore}
                                    value={100}
                                    label=""
                                    name={"conocimiento"}
                                    type="radio"
                                    id={`5`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[4].metrica == 80}
                                    onChange={handleMetricScore}
                                    value={80}
                                    label=""
                                    name={"conocimiento"}
                                    type="radio"
                                    id={`5`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[4].metrica == 60}
                                    onChange={handleMetricScore}
                                    value={60}
                                    label=""
                                    name={"conocimiento"}
                                    type="radio"
                                    id={`5`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[4].metrica == 40}
                                    onChange={handleMetricScore}
                                    value={40}
                                    label=""
                                    name={"conocimiento"}
                                    type="radio"
                                    id={`5`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="mb-3 d-flex flex-wrap justify-content-center align-items-center">
                                  <Form.Check
                                    inline
                                    checked={metricScore[4].metrica == 10}
                                    onChange={handleMetricScore}
                                    value={10}
                                    label=""
                                    name={"conocimiento"}
                                    type="radio"
                                    id={`5`}
                                    disabled={false}
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <Card
                className="border border-muted rounded  bg-white"
                style={{ border: "1px solid #ced4da" }}
              >
                <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
                  <Row className="justify-content-sm-center align-items-center flex-nowrap">
                    <Col md="12">
                      <Row className="mb-0">
                        <Table striped bordered hover responsive>
                          <tbody>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                Nivel de Eficacia
                              </td>
                              <td
                                className="text-center"
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                81% - 100%
                              </td>
                              <td
                                className="text-center"
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                60% - 80%
                              </td>
                              <td
                                className="text-center"
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                0% - 59%
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                Calificación
                              </td>
                              <td
                                className="text-center"
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                Eficaz <br /> Resultado satisfactorio - Alto
                              </td>
                              <td
                                className="text-center"
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                Eficaz <br /> Resultado suficiente
                              </td>
                              <td
                                className="text-center"
                                style={{ minWidth: "200px" }}
                                // rowspan="6"
                                // scope="col"
                              >
                                No eficaz <br /> Resultado insuficiente
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <Col md="12" className="mb-0 px-0 mt-3">
                          <Row className="mb-0">
                            <Form.Label column xs="auto" className="text-dark">
                              Comentarios Adicionales
                            </Form.Label>
                            <Col md={12} xs="auto">
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    type="text"
                                    name="comentarios_adicionales"
                                    id="comentarios_adicionales"
                                    as="textarea"
                                    value={comment}
                                    onChange={handleComment}
                                  ></Form.Control>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <Row className="justify-content-sm-end align-items-center flex-nowrap my-3">
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      id=""
                      variant="secondary"
                      size="sm"
                      className="mx-2 rounded-pill"
                      onClick={handleSubmit}
                    >
                      <b>Guardar</b>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Col md="12">
                <Row className="mt-5 mb-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                  <Col md="4" xs="auto" className="mx-auto my-5">
                    <Row className="mt-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                      <Col
                        className="mb-1 d-flex flex-wrap justify-content-center align-items-center"
                        md="12"
                      >
                        <p className="text-uppercase">
                          <b>
                            {" "}
                            {formEvalCapa &&
                            formEvalCapa.formulario &&
                            formEvalCapa.formulario.jefe_inmediato_nombre
                              ? formEvalCapa.formulario.jefe_inmediato_nombre
                              : ""}
                          </b>
                        </p>
                      </Col>
                      <Col md="12">
                        <div className="px-2">
                          <hr
                            style={{
                              borderColor: "black",
                            }}
                          />
                        </div>
                      </Col>
                      <Col md="12">
                        <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                          <Col
                            className="d-flex flex-wrap justify-content-center align-items-center"
                            md="12"
                          >
                            <p className="text-uppercase">
                              <b>FIRMA DEL EVALUADOR JEFE DEL AREA</b>
                            </p>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="4" xs="auto" className="mx-auto my-5">
                    <Row className="mt-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                      <Col
                        className="mb-1 d-flex flex-wrap justify-content-center align-items-center"
                        md="12"
                      >
                        <p className="text-uppercase">
                          <b>
                            {" "}
                            {formEvalCapa &&
                            formEvalCapa.formulario &&
                            formEvalCapa.formulario.responsable
                              ? formEvalCapa.formulario.responsable
                              : ""}
                          </b>
                        </p>
                      </Col>{" "}
                      <Col md="12">
                        <div className="px-2">
                          <hr
                            style={{
                              borderColor: "black",
                            }}
                          />
                        </div>
                      </Col>
                      <Col md="12">
                        <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                          <Col
                            className="d-flex flex-wrap justify-content-center align-items-center"
                            md="12"
                          >
                            <p className="text-uppercase">
                              <b> FIRMA DEL OFICIAL DE FORMACION</b>
                            </p>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Col>
          </div>
        </Container>
      </div>
    </>
  );
};

export default FormEvalCapa;
